import { render, staticRenderFns } from "./AyudaTemaCuenta.vue?vue&type=template&id=09bb44e0"
import script from "./AyudaTemaCuenta.vue?vue&type=script&lang=js"
export * from "./AyudaTemaCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports